type ProfileDataItemProps = {
  header: string,
  value: string,
  id: string,
}

const ProfileDataItem = ({ header, value, id }: ProfileDataItemProps) => {
  return (
    <div className='flex w-full bg-white rounded flex-col justify-center items-start gap-1 pt-2 px-4'>
      <div className="flex items-center gap-2">
        <div className="flex flex-col justify-center items-start">
          <div className="font-libre-franklin text-xs text-[#76A8FF] font-semibold" id={`${id}_header`}>
            {header}
          </div>
          <div className="text-blue_text font-roboto" id={`${id}_value`}>
            {value}
          </div>
        </div>
      </div>
      <div className="h-[1px] bg-neutral_weak w-full" />
    </div>
  )
}

export default ProfileDataItem
